// src/useChatStore.js
import { BitacoraSalaProps } from '@/shared/components/ui/Bitacora/BitacaraSala/BitacoraSala';
import { AlertSeverityEnum } from '@/shared/interfaces/erp/global/errors.interface';
import { DataAlertBitacora, DataLoadMessages, DataMessageBitacora, ISendMessage } from '@/shared/interfaces/erp/bitacora.interface';
import {socket} from '@/shared/socket/socket.config';
import { useAuthStore } from '@/store/auth/auth.store';
import { useUitsTsxStore } from '@/store/ui/uitsx.store';
import { create } from 'zustand';

const setAlert = useUitsTsxStore.getState().setAlert;
interface useSocketIOStoreProps {
  isConnected: boolean;
  username: string | null;

  connect: (username: string) => void, //on
  setUsername: (username: string) => void, //emit
  disconnect: () => void, // on
  socketOff: (name: string) => void
  loadMessages: () => void, //on

  ///* privados
  setMessagePrivate: (from: string, to: string, message: string) => void, //emit
  newPrivateMessage: () => void, //on
  startPrivateChat: (from: string, receiver: string) => void, //emit

  ///* sala
  joinRoom: (username: string, room: string) => void; //emit
  sendMessage: (dataBitacoraProps: ISendMessage) => void; //emit
  onNewMessage: () => void; //on

  ///* Mensajes no leidos
  unreadMessages: (username: string) => void; //emit
  onUnreadMessages: () => void; //on
  unreadMessagesUpdate: () => void //on

  ///* Alertas
  sendAlert: (from: string, to: string, content: string, room: string) => void //emit
  receiveAlert: () => void //on
  modalBitactora: boolean;
  setModalBitactora: (modalBitactora: boolean) => void;
  bitacoraProps: BitacoraSalaProps | null;
  setBitacoraProps: (bitacoraProps: BitacoraSalaProps | null) => void;

  ///* Bitacora sala
  listMessage: DataLoadMessages;
  setListMessage: (listMessage: DataLoadMessages) => void;
  addMessage: (newMessage: DataMessageBitacora) => void;
}


const useSocketBitacoraStore = create<useSocketIOStoreProps>((set, get) => ({
  username: null,
  isConnected: false,
  connect: (username) => {

    socket?.on('connect', () => {
      set({ isConnected: true })
            
      get().setUsername(username)

      get().receiveAlert()

      set({ username: username })


      console.log(`Conectado al socket ${username}`);

    });

    get().disconnect()

  },
  setUsername: (username) => {
    if (!get().isConnected) return;
    socket?.emit('setUsername', username);
    set({ username: username })
  },

  ///* Unirse a una sala
  ///* room - idPreagendamiento
  joinRoom(username, room) {
    if (!get().isConnected) return;
    socket?.emit('joinRoom', { username, room });
  },

  ///* Enviar un mensaje a una sala
  sendMessage(data) {
    if (!get().isConnected) return;
    console.log(data, 'data_enviar');

    socket?.emit('sendMessage', data);
  },

  ///* Reciber nuevo mensaje en la sala
  onNewMessage() {
    if (!get().isConnected) return;
    socket?.on('newMessage', (newMessage: DataMessageBitacora) => {
      get().addMessage(newMessage)
    });
  },


  ///* Iniciar un mensaje privado
  startPrivateChat: (from: string, receiver: string) => {
    if (!get().isConnected) return;

    socket?.emit('startPrivateChat', { from: from, to: receiver });
  },

  ///* Enviar mensajes privados
  setMessagePrivate: (from: string, to: string, message: string) => {
    if (!get().isConnected) return;
    socket?.emit('privateMessage', {
      from: from,
      to: to,
      content: message
    }, (data: any) => {
      console.log(data);
    })

  },

  ///* Cargar historial de mensajes
  loadMessages: () => {
    if (!get().isConnected) return;
    socket?.on('loadMessages', (data: DataLoadMessages) => {
      console.log(data, 'loadMessages');
      set({ listMessage: data })
    });
  },

  ///* Reciber nuevo mensaje privado
  newPrivateMessage: () => {
    if (!get().isConnected) return;
    socket?.on('newPrivateMessage', (message: DataMessageBitacora) => {
      setAlert(message, AlertSeverityEnum.info);
    })
  },


  ///* Mensajes no leidos
  unreadMessages: () => {
    if (!get().isConnected) return;
    socket?.emit('unreadMessages', { username: get().username });
  },
  ///* Todo: obsoleto
  onUnreadMessages: () => {
    if (!get().isConnected) return;
    socket?.on('onUnreadMessages', (data: any) => {
      console.log(data, 'mensajes no leidos historial sola una vez');
    });
  },

  unreadMessagesUpdate: () => {
    if (!get().isConnected) return;
    socket?.on('unreadMessagesUpdate', (data: any) => {
      console.log(data, 'mensajes no leidos en tiempo real');
    });
  },

  disconnect: () => {
    socket?.on('disconnect', () => {
      console.log('Desconectado del servidor socket');
      set({ isConnected: false })
    })
  },
  socketOff: (name: string) => {
    socket?.off(name);
  },

  ///* Alerta
  sendAlert(from, to, content, room) {
    if (!get().isConnected) return;
    socket?.emit('sendAlert', { from, to, content, room });
  },
  receiveAlert() {
    if (!get().isConnected) return;
    const departamento = useAuthStore.getState().user?.departamento ?? '';

    socket?.on('receiveAlert', (data: DataAlertBitacora) => {
      console.log(data);

      if (data.to == get().username || data.to == departamento)
        setAlert(data, AlertSeverityEnum.info);
    });

  },

  modalBitactora: false,
  setModalBitactora(modalBitactora) {
    set({ modalBitactora })
  },
  bitacoraProps: null,
  setBitacoraProps(bitacoraProps) {
    set({ bitacoraProps })
  },

  ///* Bitacora sala
  listMessage: { room: '', messages: [] },
  setListMessage: (listMessage) => {
    set({ listMessage })
  },
  addMessage: (newMessage) => {
    if (newMessage.room === get().listMessage.room)
      set((state) => ({
        listMessage: {
          ...state.listMessage,
          messages: [...state.listMessage.messages, newMessage],
        },
      }))
  }


}));


export default useSocketBitacoraStore;
